import { mapState } from "vuex";

export default {
    name: "UserAvatar",
    mixins: [],
    props: {
        item: {
            type: [Object, String],
            default: () => {}
        },
        user_id: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "40"
        },
        largeIcon: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        user: {
            avatar: {}
        }
    }),
    computed: {
        ...mapState({
            uxDocs: state => state.Chat.uxDocs
        }),
        // Kiey AI synthetic user — render a wrench icon instead of initials.
        isKieyAI() {
            const direct = this.user_id === 'kiey-ai-assistant';
            const fromUser = this.user && (this.user.user_id === 'kiey-ai-assistant'
                                        || this.user.id === 'kiey-ai-assistant'
                                        || this.user.user_role === 'ai_assistant');
            return Boolean(direct || fromUser);
        },
        kieyAIIconSize() {
            const s = parseInt(this.size) || 40;
            return Math.round(s * 0.5);
        },
        avatarColor() {
            if (this.isKieyAI) return '#3FC586'; // Kiey AI tint (matches iOS palette)
            if (this.user && this.user.avatar && this.user.avatar.pro_pic) return 'white';

            const role = this.user && this.user.user_role ? this.user.user_role : '';
            switch (role) {
                case 'agent':
                case 'owner':
                case 'super_user':
                    return '#061D47';
                case 'vendor':
                case 'employee':
                    return '#2E7D32';
                default: {
                    // Clients + unknown — pastel palette based on name hash
                    const palette = ['#DDE7F5', '#E8F3F0', '#F1E8F6', '#FDECEF', '#FFF4E5', '#EAF7EA'];
                    const name = this.user ? ((this.user.first_name || '') + (this.user.last_name || '')) : '';
                    if (name) {
                        let hash = 0;
                        for (let i = 0; i < name.length; i++) hash += name.charCodeAt(i);
                        return palette[Math.abs(hash) % palette.length];
                    }
                    return palette[0];
                }
            }
        },
        initialsColor() {
            const role = this.user && this.user.user_role ? this.user.user_role : '';
            switch (role) {
                case 'agent':
                case 'owner':
                case 'super_user':
                case 'vendor':
                case 'employee':
                    return '#ffffff';
                default:
                    return '#374151';
            }
        },
        initialsSize() {
            const s = parseInt(this.size) || 40;
            return Math.round(s * 0.38) + 'px';
        },
    },
    watch: {
        user_id: {
            handler() {   
                this.userInfo();                             
            },
            deep: true
        },
        item: {
            handler(data) {
                if (data) {
                    this.user = {
                        ...data
                    };
                    this.userInfoFromObject();
                }
            },
            deep: true
        }
    },
    created(){
        this.userInfo();
        if(this.item) {
            this.user = {
                ...this.item
            };
            this.userInfoFromObject();
        }
    },
    methods: {
        userAvatar(user) {
            let resp;
            if (user) {
                if (user.profile_picture) {
                    resp = {data: user.profile_picture, pro_pic: true}
                } else if (user.first_name) {
                    resp = {data: (user.first_name || '').charAt(0).toUpperCase() + (user.last_name || '').charAt(0).toUpperCase(), pro_pic: false}
                }
            } else {
                resp = "";
            }
            return resp;
        },
        userInfo(){            
            let self = this;            
            if(Object.keys(self.uxDocs).includes(self.user_id)){
                self.user = self.uxDocs[self.user_id];
                self.user.avatar = self.userAvatar(self.user);
            }                       
        },
        userInfoFromObject() {
            this.user.avatar = this.userAvatar(this.user);
        }
    }
}